import axios from '@/config/axios.config';
import { creatUrlParams } from '@/utils/url';

let devApi = {
  getAccess: '/api/v1/api-auth/getAccessOut-tianyu',
  commonPhases: '/api/v1/invoke-v2/phases',
}

const previewMixin = {
  data() {
    return {
      tokenRes: '',
      tokenRes2: ''
    }
  },
  methods: {
    async getDevBase(url = '', params, url2  = '', params2) {
      url = creatUrlParams(url, params)
      url2 = creatUrlParams(url2, params2)
      let {
        platformcode,
        ticket
      } = this.$route.query;
      url = window.location.origin + url
      url2 = window.location.origin + url2
      let reqparams = {
        "platformcode": platformcode,
        "ticket": ticket,
        "url": url,
        "url2": url2
      };
      try {
        let res = await axios.devPost(devApi.getAccess, {}, reqparams);
        if (res) {
          this.tokenRes = res[0]
          this.tokenRes2 = res[1]
        }
      } catch (err) {
        this.isPreview = false;
        this.errText = err.msg;
      }
    },
    async sendDevRequest(url = '', params = {}, type = 1) {
      let res = type === 1 ? this.tokenRes : this.tokenRes2
      if (!res || res.Authorization.indexOf('null') > -1 || res.Authorization.length < 12) {
        return Promise.reject({
          msg: 'access_token 无效'
        })
      }
      url = creatUrlParams(url, params)
      return axios.devGet(url, {}, {
        ...res,
        'Authorization': res.Authorization
      });
    }
  },
}

export default previewMixin;



// WEBPACK FOOTER //
// ./src/pages/previewV2/mixins/previewMixin.js